import React from "react";

const ReceiptHeader = ({ office, subs }) => {
  return (
    <div className="container">
      <div className="header">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
          }}
        >
          <img
            className="py-2"
            src="../images/logo.png"
            alt="Intitution Logo"
            style={{ maxWidth: 80 }}
          />
          <div style={{ paddingTop: 10 }}>
            <h1
              style={{
                marginTop: 0,
                marginBottom: 3,
                color: "blue",
                fontSize: 40,
              }}
            >
              Kebbi State Polytechnic Dakingari
            </h1>
            
            <div className="text-uppercase">Central Administration</div>
            <div className="text-uppercase">
              Nassarawa Annex Campus Dakingari, Kebbi State, Nigeria
            </div>
          </div>
        </div>
      </div>

      <div className="lettertohead">
        <div className="">
          <div>
            <b style={{ color: "red" }}>The Rector:</b>
          </div>
          <b className="text-uppercase">
            Dr. Rector's Ful Name{" "}
            <small style={{ fontSize: 10 }}>MICCON, NCSN</small>
          </b>
          <div>HND, MSc, PhD (ATBU)</div>
          <div>rector@kespodak.edu.ng</div>
        </div>
        <div className="">
          <div>
            <b style={{ color: "red" }}>REGISTRAR:</b>
          </div>
          <div className="text-uppercase">
            <b>
              Alh. Registrar's Full Name,{" "}
              <small style={{ fontSize: 10 }}>MNIM, FIICA</small>
            </b>
          </div>
          <div>BA (HONS) (BUK)</div>
          <div>registrar@kespodak.edu.ng</div>
        </div>
      </div>
      <div className="officename">
        <div>{office !== "" && office}</div>
        <small>{subs && subs}</small>
      </div>
    </div>
  );
};

export default ReceiptHeader;
